import { type ReactNode, type SyntheticEvent } from 'react';
import { format } from '../DataGrid';
import type { Column, Record } from '../types';

export function editableColumn<T extends EditableRecord>(
  columnConfig: EditableColumn<T> = {} as any,
): EditableColumn<T> {
  return {
    isRecordEditing(record: T) {
      return Boolean(record.isEditing);
    },

    setRecordEditing(record: T, value: boolean) {
      record.setEditing?.(value);
    },

    renderCell(record: T, column: EditableColumn<T>) {
      if (!column.isRecordEditing?.(record)) {
        return format(record, column);
      }

      if (typeof column.renderEditor === 'function') {
        return column.renderEditor(record, column);
      }

      return (
        <input
          name={column.id as string}
          onChange={record.handleChange}
          type="text"
          value={record[column.id] as string}
        />
      );
    },

    ...columnConfig,
  };
}

export interface EditableColumn<T> extends Column<T> {
  isRecordEditing?(record: T): boolean;
  renderEditor?(record: T, column: Column<T>): ReactNode;
  setRecordEditing?(record: T, value: boolean): void;
}

export interface EditableRecord extends Record {
  handleChange?: (event: SyntheticEvent) => void;
  isEditing?: boolean;
  setEditing?: (value: boolean) => void;
}
